// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"c10165c5","27":"11633ee7","174":"8534eec0","216":"1c0aafb9","272":"ec51b2cd","281":"96f6717e","310":"5ea3f2e3","432":"017976ec","488":"32c3fafd","627":"9396d126","675":"9702b6f0","909":"023e5ba3"}[chunkId] + ".chunk.js";
};